module.exports = __webpack_public_path__ + "static/assets/6702c73cb861cb7d6d25b346cfb7bdde.gif";